import { lazy } from 'react';

const DetailView = lazy(() => import('./DetailView'));
export { DetailView };
